import { API_BASE_URL } from "../../services/api";

export default function DriverDocumentViewerModal({ open, onClose, files }) {
  if (!open) return null;

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div className="modalCard documentModal" onClick={(e) => e.stopPropagation()}>
        <div className="modalHeader">
          <h3>Documents ({files.length})</h3>
         <button className="modalCloseBtn" onClick={onClose} aria-label="Fermer">
    &times;
  </button>
        </div>

        
        <div className="docViewerList">
          {files.map((file, i) => {
            const url = `${API_BASE_URL}/documents/drivers/${file.value}`;
            const isImage = file.value.match(/\.(jpg|jpeg|png)$/i);

            return (
              <div key={i} className="docItem">
                {isImage ? (
                  <div className="imageWrapper">
                    <img src={url} alt={`Doc ${i}`} className="docPreview" />
                    <a href={url} target="_blank" rel="noreferrer" className="zoomLink">
                      Agrandir
                    </a>
                  </div>
                ) : (
                  <div className="filePlaceholder">
                    <span className="fileIcon">📄</span>
                    <a href={url} target="_blank" rel="noreferrer">Voir le fichier PDF/Doc</a>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="modalFooter">
          <button className="btnGhost" onClick={onClose}>Fermer</button>
        </div>
      </div>
    </div>
  );
}